<template>
  <van-nav-bar
    v-bind="$attrs"
    v-on="$listeners"
    :left-text="leftText"
    @click-left="clickLeft"
  />
</template>

<script>
// 这个组件的意义在于 每次申请组件，还得绑定本地的返回事件。很不科学。
import {NavBar} from 'vant';

export default {
  name: 'sby-nav-bar',
  components: {
    NavBar
  },
  props: {
    to: String,
    leftText: {
      type: String,
      default: '返回'
    }
  },
  methods: {
    clickLeft() {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sby-nav-bar.vue